import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SimulatorModel } from '../models/SimulatorModel';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { PolicyType } from '../models/superbit-api-models';
import { GeneralDataModel } from '../models/GeneralDataModel';
import { SuesModel } from '../models/SuesModel';
import { set } from 'lodash';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setFilterCleaned } from '../app-context/suesSlice';


type Props = {
    filter: any;
    policyTypes: any[];
    productionTypes: any[];
    onApprove: Function;
    onClear: Function;
    onHide: Function;
};

const AdvancedSuesSearch = (props: Props) => {
    const dispatch = useDispatch();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const suesModel = new SuesModel();
    const offerProductionModel: OfferProductionModel = new OfferProductionModel();
    const [filter, setFilter] = useState<any>(props.filter ? props.filter : {});
    const [productionType, setProductionType] = useState<string>('-1');
    const [leadSource, setLeadSource] = useState<string>('-1');
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [handlersList, setHandlersList] = useState<any[]>([]);
    const [createdBy, setCreatedBy] = useState<string>('');
    const [handledBy, setHandledBy] = useState<string>('');
    
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');
    const [selectedThirdPartyInsuranceCompany, setThirdPartySelectedInsuranceCompany] = useState<string>('');
    const [selectedDefendantInsuranceCompany, setSelectedDefendantInsuranceCompany] = useState<string>('');

    const [routesList, setRoutesList] = useState<any[]>([]);
    const [selectedRouteId, setSelectedRouteId] = useState<string | null>(null);

    const [selectedDateParam, setSelectedDateParam] = useState<string>('0')
    const [startDateFrom, setStartDateFrom] = useState<Date | null> (null);
    const [startDateTo, setStartDateTo] = useState<Date | null> (null);

    const [agents, setAgents] = useState<any[]>([])
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<string>('0');

    
    const [vehiclePolicyTypes, setVehiclePolicyTypes] = useState<any[]>([]);
    const [vehiclePolicyType, setVehiclePolicyType] = useState<string>('-1');
    
    const [sueStatusesList, setSueStatusesLists] = useState<any[]>([]);
    const [sueStatus, setSueStatus] = useState<string>('-1');
    
    const [sueActivityStatusesList, setSueActivityStatusesList] = useState<any[]>([]);
    const [sueActivityStatus, setSueActivityStatus] = useState<string>('-1');

    const [sueTypesList, setSueTypesLists] = useState<any[]>([]);
    const [sueType, setSueType] = useState<string>('-1');

    const [policyType, setPolicyType] = useState<string>('-1');

    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);
    const [selectedPolicyStatus, setSelectedPolicyStatus] = useState<string>('0');
    const [handlersAllList, setHandlersAllList] = useState<any[]>([]);

    const filterCleaned = useSelector((state: RootState) => state.sues.filterCleaned);
    

    const loadStateFromLocalStorage = () => {
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            if(suesFilter.sueTypeId){
                setSueType(suesFilter.sueTypeId.toString());
            }
            if(suesFilter.sueStatusId){
                setSueStatus(suesFilter.sueStatusId.toString());
            }
            if(suesFilter.sueActivityStatusId){
                setSueActivityStatus(suesFilter.sueActivityStatusId);
            }
            if(suesFilter.dateType){
                setSelectedDateParam(suesFilter.dateType);
            }
            if(suesFilter.from){
                setStartDateFrom(new Date(suesFilter.from));
            }
            if(suesFilter.to){
                setStartDateTo(new Date(suesFilter.to));
            }
            if(suesFilter.branchId){
                setSelectedAgent(suesFilter.branchId);
            }
            if(suesFilter.handlerId){
                const selected = handlersList.find((a: any)=> a.value == suesFilter.handlerId);
                if(selected) {
                    setHandledBy(selected.label)
                } else {
                    setHandledBy('');
                }
            }
            console.log('suesFilter.insuranceTypeIds', suesFilter.insuranceTypeIds)
            if(suesFilter.insuranceTypeIds && suesFilter.insuranceTypeIds.length > 0){
                setPolicyType(suesFilter.insuranceTypeIds[0].toString());
            }
            if(suesFilter.vehiclePolicyType){
                setVehiclePolicyType(suesFilter.vehiclePolicyType.toString());
            }
            if (typeof suesFilter.insuranceCompanyId !== 'undefined') {
                // if (suesFilter.insuranceCompanyId === '-1') {
                //     setSelectedInsuranceCompany('פלוס שירותי דרך');
                // } else {
                    const selected = insuranceCompanyList.find((a: any)=> a.value == suesFilter.insuranceCompanyId);
                    if(selected) {
                        setSelectedInsuranceCompany(selected.label)
                    } else {
                        setSelectedInsuranceCompany('');
                    }
                // }
                getRoutesList(suesFilter.insuranceCompanyId);
            }
            if (typeof suesFilter.thirdPartyInsuranceCompanyId !== 'undefined') {
                if (suesFilter.thirdPartyInsuranceCompanyId === '-1') {
                    setThirdPartySelectedInsuranceCompany('פלוס שירותי דרך');
                } else {
                    const selected = insuranceCompanyList.find((a: any)=> a.value == suesFilter.thirdPartyInsuranceCompanyId);
                    if(selected) {
                        setThirdPartySelectedInsuranceCompany(selected.label)
                    } else {
                        setThirdPartySelectedInsuranceCompany('');
                    }
                }
                getRoutesList(suesFilter.thirdPartyInsuranceCompanyId);
            }
            // if (typeof suesFilter.defendantCompanyId !== 'undefined') {
            //     const selected = insuranceCompanyList.find((a: any)=> a.value == suesFilter.defendantCompanyId);
            //     if(selected) {
            //         setSelectedDefendantInsuranceCompany(selected.label)
            //     } else {
            //         setSelectedDefendantInsuranceCompany('');
            //     }
            //     getRoutesList(suesFilter.defendantCompanyId);
            // }
        }
    }

    const init = async() => {

        loadStateFromLocalStorage();

        rebuildCreatorsList(-1);

        const signingUsersData = await generalModel.getClaimHandlers();
        setHandlersAllList(signingUsersData.map((su: any)=> {
            return {
                label: su.fullName,
                value: su.id,
                active: su.status === 0
            }
        }));
        
        // const handlersData = await generalModel.getClaimHandlers();
        // if (handlersData) {
        //     setHandlersList(handlersData.map((h: any) => {
        //         return {
        //             label: h.fullName,
        //             value: h.id
        //         }
        //     }))
        // }
        // rebuildHandlersList(-1);
        
        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [{
            value: '-1',
            label: 'פלוס שירותי דרך'
        }];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        setInsuranceCompanyList(fixedInsuranceCompanies);

        const InsuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const insuranceTypesKeys = Object.keys(InsuranceTypesData);
        const insuranceTypesList: any[] = [];
        insuranceTypesKeys.forEach((key: string) => {
            const item = InsuranceTypesData[key];
            insuranceTypesList.push(
                {
                    label: item.description,
                    value: item.id.toString()
                })

        });
        setVehiclePolicyTypes(insuranceTypesList);

        

        try {
            const sueStatusesData = await suesModel.sueStatusGetAll();
            sueStatusesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
            setSueStatusesLists(sueStatusesData.map((st: any)=>{
                return {
                    label: st.name,
                    value: st.id.toString()
                }
            }));
        } catch (error) {
            setSueStatusesLists([]);
        }
        try {
            const sueActivityStatusesData = await suesModel.sueActivityStatusGetAll();
            sueActivityStatusesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
            setSueActivityStatusesList(sueActivityStatusesData.map((st: any)=>{
                return {
                    label: st.name,
                    value: st.id.toString()
                }
            }));
        } catch (error) {
            setSueActivityStatusesList([]);
        }
        
        try {
            const sueTypesData = await suesModel.sueTypeGetAll();
            sueTypesData.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
            setSueTypesLists(sueTypesData.map((st: any)=>{
                return {
                    label: st.name,
                    value: st.id.toString()
                }
            }));
            // setSueTypesLists(sueTypesList);
        } catch (error) {
            setSueTypesLists([]);
        }

        
        const agentsData = await simulatorModel.getCustomerCardAgents();
        await setAgents(agentsData);
        await setAgentsList(agentsData.map((a: any)=>{
            return {
                value: a.id,
                label: a.name
            }
        }));
        
        const policyStatusesData = await offerProductionModel.getPolicyStatuses();
        setPolicyStatuses(policyStatusesData.map((ps: any)=>{ 
            return {
                label: ps.name,
                value: ps.id.toString()
            }
        }))

    }

    const setDataToLocalStorage = (key: string, value: any) => {
        const suesFilterData = localStorage.getItem('lastSuesFilter');
        if (suesFilterData) {
            let suesFilterObj = JSON.parse(suesFilterData);
            suesFilterObj[key] = value;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilterObj));
        }
    }

    const rebuildCreatorsList = (status: number) => {
        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsList), 'id', status);
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setCreatorsList(newCreatorsList)
        }

    }
    const rebuildHandlersList = (status: number) => {
        // const creatorsList = localStorage.getItem('creatorsList');
        if (handlersAllList) {
            let dataList = handlersAllList;
            switch (status) {
                case 0:
                    dataList = handlersAllList.filter((i: any) => i.active === true)
                    break;
                case 1:
                    dataList = handlersAllList.filter((i: any) => i.active === false)
                    break;
                default:
                    break;
            }
            console.log('rebuildHandlersList', status, dataList);
            const newCreatorsList: any = [
                ...dataList
            ]
            setHandlersList(newCreatorsList)
        }

    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', show: number = -1) =>{
        const items: any[] = [];
        source.forEach((i: any)=> {
            let include: boolean = false;
            switch (show) {
                case 0:
                    if (i.status === 0) {
                        include = true;
                    }
                    break;
                case 1:
                    if (i.status === 1) {
                        include = true;
                    }
                    break;
            
                default:
                    include = true;
                    break;
            }
            if (include) {
                items.push(
                    {
                        label: i.fullName,
                        value: i[param],
                        active: i.status === 0
                    }
                );
            }
        })
        console.log('buildOptionsForSelect', items);
        return items;
    }

    // const onCreatorChange = async (e: any) => {
    //     const creatorName = e.target.value;
    //     const newFilter:any = filter;
    //     newFilter.creatorUserId = undefined;
    //     const selected = creatorsList.find((a: any)=> a.label == creatorName);
    //     setCreatedBy(creatorName);
    //     if(selected) {
    //         switch (selected.value) {
    //             case '-1':
    //                 newFilter.createdBy = undefined;
    //                 break;
    //             case '0':
    //                 setCreatedBy('');
    //                 // newFilter.createdBy = parseInt(selected.value);
    //                 rebuildCreatorsList(0);
    //                 break;
    //             case '1':
    //                 setCreatedBy('');
    //                 // newFilter.createdBy = parseInt(selected.value);
    //                 rebuildCreatorsList(1);
    //                 break;
    //             case '2':
    //                 setCreatedBy('');
    //                 // newFilter.createdBy = parseInt(selected.value);
    //                 rebuildCreatorsList(-1);
    //                 break;
    //             default:
    //                 newFilter.createdBy = '3';
    //                 newFilter.creatorUserId = selected.value;
    //                 break;
    //         }
    //         setFilter(newFilter);
    //     } else {
    //         newFilter.createdBy = undefined
    //         setFilter(newFilter);
    //     }
    // }
    
    const clearCreatedBy = () => {
        const newFilter:any = filter;
        newFilter.createdBy = undefined;
        newFilter.creatorUserId = undefined;
        setCreatedBy('');
        setFilter(newFilter);
    }

    const onHandlerChange = async (e: any) => {
        const handlerName = e.target.value;
        const newFilter:any = filter;
        newFilter.handlerId = undefined;
        const selected = handlersList.find((a: any)=> a.label == handlerName);
        setHandledBy(handlerName)
        if(selected) {
            newFilter.handlerId = selected.value;
            // switch (selected.value) {
            //     case '-1':
            //         newFilter.underwriterType = undefined;
            //         rebuildHandlersList(-1);
            //         break;
            //     case '0':
            //         newFilter.underwriterType = parseInt(selected.value);
            //         rebuildHandlersList(0);
            //         setHandledBy('');
            //         break;
            //     case '1':
            //         newFilter.underwriterType = parseInt(selected.value);
            //         rebuildHandlersList(1);
            //         setHandledBy('');
            //         break;
            //     case '2':
            //         newFilter.underwriterType = parseInt(selected.value);
            //         rebuildHandlersList(-1);
            //         setHandledBy('');
            //         break;
            //     default:
            //         newFilter.underwriterType = '3';
            //         newFilter.underwriterUserId = selected.value;
            //         rebuildHandlersList(-1);
            //         break;
            // }
            setFilter(newFilter);
        } else {
            rebuildHandlersList(-1);
            newFilter.createdBy = undefined
            setFilter(newFilter);
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.handlerId = selected ? selected.value : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
    }

    const clearHandledBy = () => {
        const newFilter:any = filter;
        // newFilter.underwriterType = undefined;
        newFilter.handlerId = undefined;
        setHandledBy('')
        setFilter(newFilter);
    }

    const onInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setSelectedInsuranceCompany(companyName);
        setSelectedRouteId(null);
        const selected = insuranceCompanyList.find((a: any)=> a.label == companyName);
        const newFilter = filter;
        if(selected) {
            newFilter.insuranceCompanyId = selected.value
            setSelectedInsuranceCompany(selected.label)
            setFilter(newFilter);
            getRoutesList(selected.value);
        } else {
            newFilter.insuranceCompanyId = undefined
            setFilter(newFilter);
            setRoutesList([])
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.insuranceCompanyId = selected ? selected.value : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
    }

    const onThirdPartyInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setThirdPartySelectedInsuranceCompany(companyName);
        setSelectedRouteId(null);
        const selected = insuranceCompanyList.find((a: any)=> a.label == companyName);
        const newFilter = filter;
        if(selected) {
            newFilter.thirdPartyInsuranceCompanyId = selected.value
            setThirdPartySelectedInsuranceCompany(selected.label)
            setFilter(newFilter);
            getRoutesList(selected.value);
        } else {
            newFilter.thirdPartyInsuranceCompanyId = undefined
            setFilter(newFilter);
            setRoutesList([])
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.thirdPartyInsuranceCompanyId = selected ? selected.value : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
    }

    // const onDefendantInsuranceCompanyChange = async (e: any) => {
    //     const companyName = e.target.value;
    //     setSelectedDefendantInsuranceCompany(companyName);
    //     const selected = insuranceCompanyList.find((a: any)=> a.label == companyName);
    //     const newFilter = filter;
    //     if(selected) {
    //         newFilter.defendantCompanyId = selected.value
    //         setSelectedDefendantInsuranceCompany(selected.label)
    //         setFilter(newFilter);
    //         getRoutesList(selected.value);
    //     } else {
    //         newFilter.defendantCompanyId = undefined
    //         setFilter(newFilter);
    //         setRoutesList([])
    //     }
    //     const lastSuesFilter = localStorage.getItem('lastSuesFilter');
    //     if (lastSuesFilter) {
    //         const suesFilter = JSON.parse(lastSuesFilter);
    //         suesFilter.defendantCompanyId = selected ? selected.value : undefined;
    //         localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
    //     }
    // }

    // const onClearDefendantInsuranceCompany= () => {
    //     const newFilter:any = filter;
    //     newFilter.insuranceCompanyId = undefined;
    //     setThirdPartySelectedInsuranceCompany('');
    //     // setSelectedRouteId(null);
    //     // setRoutesList([]);
    //     setFilter(newFilter);
    // }

    const getRoutesList = async (companyId: string) => {
        if (companyId == '-1') {
            setRoutesList([]);
            return;
        }
        setSelectedRouteId(null);
        let data: any = await simulatorModel.getRoutesByInsuranceCompany(companyId);
        if (data) {
            data = data.filter((r: any)=>r.comment && r.comment !== '')
            setRoutesList(data.map((r: any)=>{
                return {
                    value: r.id,
                    label: r.comment
                }
            }))
        } else {
            setRoutesList([])
        }
    }

    const onClearInsuranceCompany= () => {
        const newFilter:any = filter;
        newFilter.insuranceCompanyId = undefined;
        setSelectedInsuranceCompany('');
        // setSelectedRouteId(null);
        // setRoutesList([]);
        setFilter(newFilter);
    }
    const onClearThirdPartyInsuranceCompany= () => {
        const newFilter:any = filter;
        newFilter.insuranceCompanyId = undefined;
        setThirdPartySelectedInsuranceCompany('');
        // setSelectedRouteId(null);
        // setRoutesList([]);
        setFilter(newFilter);
    }

    // setThirdPartySelectedInsuranceCompany

    const onProductionTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onProductionTypeChange');
        setProductionType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.productionType = parseInt(value);
            setProductionType(value.toString());
        } else {
            newFilter.productionType = undefined;
        }
        setFilter(newFilter);
    }

    
    const onVehiclePolicyTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onVehiclePolicyTypeChange');
        setVehiclePolicyType('-1');
        const newFilter = filter;
        newFilter.vehiclePolicyTypeLabel = undefined;
        if (value !== '-1') {
            newFilter.vehiclePolicyType = parseInt(value);
            if (option) {
                newFilter.vehiclePolicyTypeLabel = (option as any).label;
                setDataToLocalStorage('vehiclePolicyTypeLabel', newFilter.vehiclePolicyTypeLabel);
            }
            setVehiclePolicyType(value.toString());
        } else {
            newFilter.vehiclePolicyType = undefined;
        }
        setDataToLocalStorage('vehiclePolicyType', newFilter.vehiclePolicyType);
        setFilter(newFilter);
    }
    
    const onPolicyTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onPolicyTypeChange');
        setPolicyType('-1');
        const newFilter = filter;
        newFilter.insuranceTypeIdLabel = undefined;
        if (value !== '-1') {
            newFilter.insuranceTypeIds=[
                value
            ];
            if (option) {
                newFilter.insuranceTypeIdLabel = (option as any).label;
                setDataToLocalStorage('insuranceTypeIdLabel', newFilter.insuranceTypeIdLabel);
            }
            setPolicyType(value.toString());
        } else {
            newFilter.insuranceTypeIds = [];
        }
        setDataToLocalStorage('insuranceTypeIds', newFilter.insuranceTypeIds);
        setFilter(newFilter);
    }

    
    const onAgentChange = (value: string, option: { label: string; value: string; }) => {
        setSelectedAgent(value);
        const newFilter = filter;
        newFilter.branchIdLabel = undefined;
        if (value !== '0') {
            newFilter.branchId = value;
            if (option) {
                newFilter.branchIdLabel = (option as any).label;
                setDataToLocalStorage('branchIdLabel', newFilter.branchIdLabel);
            }
        } else {
            newFilter.branchId = undefined;
        }
        setDataToLocalStorage('branchId', newFilter.branchId);
        setFilter(newFilter);
    }

    const onChageDateParam = (value: string, option: { label: string; value: string; }) => {
        const newFilter = filter;
        newFilter.dateType = value
        newFilter.from = undefined;
        newFilter.to = undefined;
        setSelectedDateParam(value);
        setFilter(newFilter);
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.dateType = value;
            suesFilter.from = undefined;
            suesFilter.to = undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
    }

    const onStartFilterDateFromChange = (d: Date) =>{
        console.log('onStartFilterDateFromChange-d', d, moment(d).format('YYYY-MM-DD'))
        setStartDateFrom(d)
        const newFilter = filter;
        if (d !== null) {
            newFilter.from = moment(d).format('YYYY-MM-DD');
        } else {
            newFilter.from = undefined;
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.from = d !== null ? moment(d).format('YYYY-MM-DD') : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
        setFilter(newFilter)
    }
    const onStartFilterDateToChange = (d: Date) =>{
        setStartDateTo(d)
        const newFilter = filter;
        if (d !== null) {
            newFilter.to = moment(d).format('YYYY-MM-DD');
        } else {
            newFilter.to = undefined;
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.to = d !== null ? moment(d).format('YYYY-MM-DD') : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
        setFilter(newFilter)
    }

    const handleCheckChange = async (name: string, event: any) => {
        const newFilter = filter;
       await setFilter({})
        if (event.target.checked) {
            newFilter[name] = true;
        } else {
            newFilter[name] = undefined;
        }
        await setFilter(newFilter);
    }

    const onSueStatusChange = (value: string, option: { label: string; value: string; }) => {
        setSueStatus(value);
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.sueStatusId = value
        } else {
            newFilter.sueStatusId = undefined;
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.sueStatusId = newFilter.sueStatusId;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
        setFilter(newFilter);
    }
    
    const onSueTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        setSueType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.sueTypeId = value;
            setSueType(value);
        } else {
            newFilter.sueTypeId = undefined;
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.sueTypeId = value !== '-1' ? value : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
        setFilter(newFilter);
    }
    const onSueStateChange = (value: string, option: { label: string; value: string; }) => {
        setSueActivityStatus(value);
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.sueActivityStatusId = value
        } else {
            newFilter.sueActivityStatusId = undefined;
        }
        const lastSuesFilter = localStorage.getItem('lastSuesFilter');
        if (lastSuesFilter) {
            const suesFilter = JSON.parse(lastSuesFilter);
            suesFilter.sueActivityStatusId = value !== '-1' ? value : undefined;
            localStorage.setItem('lastSuesFilter', JSON.stringify(suesFilter));
        }
        setFilter(newFilter);
    }

    const onApprove = () => {
        if (props.onApprove) {
            const newFilter = filter;
            props.onApprove(newFilter);
        }
    }
    const onClear = () => {
        console.log('onClear', 1111)
        setFilter({});
        setSelectedAgent('0');
        setVehiclePolicyType('-1');
        setPolicyType('-1');
        setSueStatus('-1');
        setSueType('-1');
        setSelectedInsuranceCompany('');
        setThirdPartySelectedInsuranceCompany('');
        setSueActivityStatus('-1');
        setSelectedDefendantInsuranceCompany('');
        setSelectedRouteId('');
        setSelectedDateParam('0');
        setHandledBy('');
        setStartDateFrom(null);
        setStartDateTo(null);
        if (props.onClear) {
            props.onClear()
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect (()=>{
        // buildOptionslist();
        init();
    }, []);

    useEffect(()=>{
        if (filterCleaned) {
            onClear();
        }
    },[filterCleaned])

    useEffect(()=>{
        console.log('props', props)
        if (props.filter) {
            setFilter(props.filter);
        }
    }, [props])

    useEffect(()=>{
        console.log('filter changed', filter)
    },[filter])

    useEffect(()=>{
        rebuildHandlersList(-1);
    }, [handlersAllList])

    return (
        <div className='sues-advanced-search rtl'>
            <div className="close-icon pointer" onClick={onClose}></div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        סוכן ביטוח
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                value={selectedAgent}
                                onChange={(value: string, option: any)=>onAgentChange(value, option)}
                                options={
                                    [
                                        {
                                        label: 'בחר סוכן ביטוח',
                                        value: '0'
                                        },
                                        ...agentsList
                                    ]
                                }
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        סוג ביטוח
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג ביטוח"
                                value={vehiclePolicyType}
                                options={[
                                    {
                                        label: 'בחר סוג ביטוח',
                                        value: '-1'
                                    },
                                    ...vehiclePolicyTypes
                                ]}
                                onChange={onVehiclePolicyTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        סוג פוליסה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג פוליסה"
                                value={policyType}
                                options={[
                                    {
                                        label: 'בחר סוג פוליסה',
                                        value: '-1'
                                    },
                                    ...props.policyTypes
                            ]}
                                onChange={onPolicyTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
        
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        סטטוס תביעה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סטטוס תביעה"
                                value={sueStatus}
                                options={[
                                    {
                                        label: 'בחר סטטוס תביעה',
                                        value: '-1'
                                    },
                                    ...sueStatusesList
                            ]}
                            onChange={(value: string, option: any)=>onSueStatusChange(value, option)}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        סוג תביעה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג תביעה"
                                value={sueType}
                                options={[
                                    {
                                        label: 'בחר סוג תביעה',
                                        value: '-1'
                                    },
                                    ...sueTypesList
                                ]}
                                onChange={onSueTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        מצב תביעה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר מצב תביעה"
                                value={sueActivityStatus}
                                options={[
                                    {
                                        label: 'בחר מצב תביעה',
                                        value: '-1'
                                    },
                                    ...sueActivityStatusesList
                                    
                            ]}
                            onChange={(value: string, option: any)=>onSueStateChange(value, option)}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        חברה מבטחת
                        </div>
                        <div className="value">
                            <input type='text'
                                        list="companies_list"
                                        placeholder='בחר חברת מבטחת'
                                        onChange={(e: any)=>onInsuranceCompanyChange(e)}
                                        value={selectedInsuranceCompany} 
                                    />
                            <datalist id="companies_list">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                {/* <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        חברה נתבעת
                        </div>
                        <div className="value">
                            <input type='text'
                                        list="companies_list3"
                                        placeholder='בחר חברת צ"ג'
                                        onChange={onDefendantInsuranceCompanyChange}
                                        value={selectedDefendantInsuranceCompany} 
                                    />
                            <datalist id="companies_list3">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedDefendantInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearDefendantInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div> */}
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        חברת צ"ג
                        </div>
                        <div className="value">
                            <input type='text'
                                        list="companies_list2"
                                        placeholder='בחר חברת צ"ג'
                                        onChange={onThirdPartyInsuranceCompanyChange}
                                        value={selectedThirdPartyInsuranceCompany} 
                                    />
                            <datalist id="companies_list2">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedThirdPartyInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearThirdPartyInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        קבוצה
                        </div>
                        <div className="value">
                            <input type='text'
                                        list="groups_list"
                                        placeholder='בחר קבוצה'
                                        onChange={(e: any)=>{}}
                                        value={''} 
                                    />
                            <datalist id="groups_list">
                                {/* {insuranceCompanyList && insuranceCompanyList.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)} */}
                            </datalist>
                            {/* <div className={`icon x-clear pointer ${selectedInsuranceCompany == '' ? 'hide' : ''}`} onClick={()=>{}}></div> */}
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className='parameter-row'>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        מטפל בתביעה
                        </div>
                        <div className="value">
                            <input type='text'
                                list="handler_list"
                                placeholder='בחר מטפל'
                                onChange={(e: any)=>onHandlerChange(e)}
                                value={handledBy} 
                            />
                            <datalist id="handler_list">
                                {handlersList && handlersList.map((c: any, i)=><option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${handledBy == '' ? 'hide' : ''}`} onClick={clearHandledBy}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}></div>
            </div>
            <div className='parameter-row'>
            <div className={`parameter-item`}>
                <div className="field">
                    <div className="title">
                    סוג תאריך
                    </div>
                    <div className="value">
                        <Select
                            style={{ width: '100%' }}
                            value={selectedDateParam}
                            onChange={(value: string, option: any)=>onChageDateParam(value, option)}
                            options={
                                [  
                                    {
                                        label: 'ללא סינון לפי תאריך ',
                                        value: '0'
                                    },
                                    {
                                        label: 'סינון לפי תאריך פתיחה ',
                                        value: 'OpeningDate'
                                    },
                                    {
                                        label: 'סינון לפי תאריך מקרה ',
                                        value: 'AccidentDateTime'
                                    },
                                    {
                                        label: 'סינון לפי תאריך יצירה ',
                                        value: 'CreatedDate'
                                    },
                                    {
                                        label: 'סינון לפי תאריך תשלום ',
                                        value: 'PaymentDate'
                                    },
                                    {
                                        label: 'סינון לפי תאריך סגירה ',
                                        value: 'ClosingDate'
                                    }
                                ]
                            }
                        />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>
            </div>
            <div className={`parameter-item`}>
                <div className="field">
                    <div className="title">
                    מ:
                    </div>
                    <div className="value">
                        <CompDatePicker disabled={selectedDateParam == '0'} value={startDateFrom} onChange={(date: Date) => onStartFilterDateFromChange(date)} />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>
            </div>
            <div className={`parameter-item`}>
                <div className="field">
                    <div className="title">
                    עד:
                    </div>
                    <div className="value">
                        <CompDatePicker disabled={selectedDateParam == '0'} value={startDateTo} onChange={(date: Date) => onStartFilterDateToChange(date)} />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>
            </div>
        </div>
        <button className="act-btn pointer" onClick={onApprove}>הצג דוח</button>
        <button className="act-btn pointer" onClick={onClear}>נקה בחירה</button>

        </div>
    )
}

export default AdvancedSuesSearch;